/**
 * The translation state
 * @class TranslationState
 */
var TranslationState = /** @class */ (function () {
    /**
     * @param {string} _key
     * @param {string|any} _value
     * @param {string}_defaultValue
     * @param {Map<string, string>}_editLinkMap
     * @param {string}_dcr
     */
    function TranslationState(_key, _value, _defaultValue, _editLinkMap, _dcr) {
        this._key = _key;
        this._value = _value;
        this._defaultValue = _defaultValue;
        this._editLinkMap = _editLinkMap;
        this._dcr = _dcr;
        this.resolved = this.value || _defaultValue || '';
    }
    Object.defineProperty(TranslationState.prototype, "key", {
        /**
         * @return {string} _key
         * @memberOf TranslationState
         */
        get: function () {
            return this._key;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TranslationState.prototype, "value", {
        /**
         * @return {string} _value
         * @memberOf TranslationState
         */
        get: function () {
            return this._value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TranslationState.prototype, "dcr", {
        /**
         * @return {string} _dcr
         * @memberOf TranslationState
         */
        get: function () {
            return this._dcr;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TranslationState.prototype, "defaultValue", {
        /**
         * @return {string} _defaultValue
         * @memberOf TranslationState
         */
        get: function () {
            return this._defaultValue;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TranslationState.prototype, "editLink", {
        /**
         * @return {string|undefined} this._editLinkMap.get(this.dcr)
         * @memberOf TranslationState
         */
        get: function () {
            return this._editLinkMap.get(this.dcr);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TranslationState.prototype, "isUsedDefault", {
        /**
         * @return {boolean} !!(this._defaultValue && !this._value)
         * @memberOf TranslationState
         */
        get: function () {
            return !!(this._defaultValue && !this._value);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TranslationState.prototype, "isValid", {
        /**
         * @return {boolean} !!(this._value || this._defaultValue)
         * @memberOf TranslationState
         */
        get: function () {
            return !!(this._value || this._defaultValue);
        },
        enumerable: false,
        configurable: true
    });
    /**
     * @return {string} resolved
     * @memberOf TranslationState
     */
    TranslationState.prototype.toString = function () {
        return this.resolved;
    };
    return TranslationState;
}());
export { TranslationState };
//# sourceMappingURL=translation-state.js.map